import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceEditProjectPortfolioNotificationState = createStateReducer(
  initialState,
  {
    [events.editProjectPortfolioSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectPortfolio",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editProjectPortfolioFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectPortfolio",
          flags: pushIf({
            duplicateName: error.portfolioNameIsNotUnique,
            emptyName: error.portfolioNameIsEmpty,
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditProjectPortfolioNotificationState };
